import api from './api';

const marketplacesettingsService = {
  getAllSettings: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.MARKETPLACEID) params.append('MARKETPLACEID', filters.MARKETPLACEID);
    if (filters.SETTINGNAME) params.append('SETTINGNAME', filters.SETTINGNAME);
    if (filters.limit) params.append('limit', filters.limit);

    const response = await api.get(`/admin/marketplacesettings${params.toString() ? '?' + params.toString() : ''}`);
    return response.data;
  },

  // Read-only, sanitised setting definitions (no SETTINGVALUE) for normal users.
  // Served by the main API at GET /marketplacesettings/schema.
  getSchema: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.MARKETPLACEID) params.append('MARKETPLACEID', filters.MARKETPLACEID);
    if (filters.SETTINGNAME) params.append('SETTINGNAME', filters.SETTINGNAME);
    if (filters.limit) params.append('limit', filters.limit);

    const response = await api.get(`/marketplacesettings/schema${params.toString() ? '?' + params.toString() : ''}`);
    return response.data;
  },

  getSettingById: async (id) => {
    const response = await api.get(`/admin/marketplacesettings/${id}`);
    return response.data;
  },

  createSetting: async (settingData) => {
    const response = await api.post('/admin/marketplacesettings', settingData);
    return response.data;
  },

  updateSetting: async (id, settingData) => {
    const response = await api.put(`/admin/marketplacesettings/${id}`, settingData);
    return response.data;
  },

  deleteSetting: async (id) => {
    const response = await api.delete(`/admin/marketplacesettings/${id}`);
    return response.data;
  }
};

export default marketplacesettingsService;
